<template>
    <v-container fluid>
    <router-link :to="{name: 'crossOrgTab', params: {tab: 'orgs'}}">&lt;&lt;Back to Organizations List</router-link>
    <p></p>
            <h3>Domain Approval</h3>

            <v-form v-model="valid" ref="form" @submit.prevent>

            <v-container grid-list-sm>
            <v-layout wrap>
                <v-flex xs12 sm5 md5>
                <v-text-field v-model="name" :rules="[rules.required]" label="Name"></v-text-field>
                </v-flex>
                <v-flex sm2 md2></v-flex>
                <v-flex xs12 sm5 md5>
                <v-text-field v-model="email" :rules="[rules.required]" label="Email"></v-text-field>
                </v-flex>
                <v-flex xs12 sm5 md5>
                <v-text-field v-model="domain" :rules="[rules.required]" label="Domain"></v-text-field>
                </v-flex>
                <v-flex xs12>
                <!-- <v-btn class="mr-4 was-orange" color="primary" outlined rounded @click="reset">Ignore</v-btn> -->
                <v-btn class="was-orange" color="primary" rounded :disabled="!valid" @click="save">Approve</v-btn>
                </v-flex>
            </v-layout>
            </v-container>
            </v-form>
</v-container>
</template>
<script>
import _ from 'lodash'
import Utility from './utility'
export default {
  data(){
      return {
        name: '',
        email: '',
        changed: false,
        valid: false,
        rules: {
            required: value => !!value || 'Required.'
        }
      }
  },
  async created () {
    this.email = this.$route.params.email
    this.name = decodeURIComponent(this.$route.params.name).replace(/\+/g, ' ')
    this.domain = this.email.substring(this.email.indexOf('@') + 1)
  },
  methods: {
    async save () {

        let approval = await this.$store.dispatch("crossorg/approveOrg", {name: this.name, email: this.email})

        if (approval === null) {
          alert('An error occurred. Please see browser console.')
        } else {
          this.changed = false
          alert('Changes have been saved.')
          this.$router.replace({name: 'crossOrgTab', params: {tab: 'orgs'}})
        }
    }
  }
}
</script>
